/** @jsxImportSource @emotion/react */
import PageDebate from "../../components/debate/pageMapingDebate/PageDebate";
const PostListDebatePage = () => {
  return (
  <>
    <PageDebate
      pathMov = {"discusstion"}
      postId={-1}
      />
    </>
  );
};

export default PostListDebatePage;
